import $ from 'jquery';

import DDTemplates from './DDTemplates';
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
// Theme specific
import Selection from './Selection';
import MemberBtn from './MemberBtn';
import Hero from './Hero';
import Banner from './Banner';
import Unlink from './Unlink';
import Notification from './Notification';
import SelectBox from './SelectBox';

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Term Banner
  $('#block-views_blocks-term-block_1-7', context).each((i, element) => {
    if (!element.Banner) {
      element.Banner = new Banner(element);
    }
  });

  // Hero
  $('#block-views_blocks-term-block_1-8', context).each((i, element) => {
    if (!element.Hero) {
      element.Hero = new Hero(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // How Do I? Selection Dropdown List
  $('.how.block', context).each((i, element) => {
    if (!element.Selection) {
      element.Selection = new Selection(element, {
        defaultText: 'How Do I?',
        addReadMore: false,
      });
    }
  });

  // Life Events Mobile Selections
  $('.life-events.block', context).each((i, element) => {
    if (!element.Selection) {
      element.Selection = new Selection(element, {
        defaultText: 'Select from Dropdown',
        addReadMore: false,
      });
    }
  });

  // Member Button Placement based on current breakpoint.
  $('.member-btn', context).each((i, element) => {
    const $nav = $('.header-bottom .primary-navigation', context);
    const $utils = $('.header-bottom .utilities', context);
    if (!element.MemberBtn && $nav.length && $utils.length) {
      element.MemberBtn = new MemberBtn(element, $nav, $utils);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu && !element.MobileMenu) {
      element.Menu = new Menu(element);
      element.MobileMenu = new MobileMenu(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      element.SmartFooter = new SmartFooter(element, $footprint);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Find Your Employer Selection Template
  $('#block-nice_menus-4 ul.nice-menu', context).each((i, element) => {
    if (!element.SelectBox) {
      element.SelectBox = new SelectBox(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Homepage Milestones/Life Events
  $('#block-views_blocks-term-block_1-11 .node-header a', context).each((i, element) => {
    if (!element.Unlink) {
      element.Unlink = new Unlink(element);
    }
  });

  // Footerlinks
  $('#block-views_blocks-term-block_1-5 .node-header a', context).each((i, element) => {
    if (!element.Unlink) {
      element.Unlink = new Unlink(element);
    }
  });

  // Site Notifications
  $('#block-views_blocks-term-block_1-12', context).each((i, element) => {
    if (!element.Notification) {
      element.Notification = new Notification(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});
